<div class="reset-password h-100 d-flex align-items-center">
  <div class="col">
    <app-email from="reset" (createdPassword)="setPassword($event)"></app-email>
  </div>
</div>
